export enum ECustomLeasingRadioOrder {
  FIRST = 'FIRST',
  SECOND = 'SECOND',
}
